import "./FeatureHighlights.css";
import { LanguageContext } from "../../context/LanguageContext";
import { useContext } from "react";

const FeatureHighlights = () => {
  const { t } = useContext(LanguageContext);

  return (
    <div>
      <h2 className="feature-highlights-header">
        {t(`featureHighlights.header`)}
      </h2>
      <p className="feature-highlight-text">
        {t(`featureHighlights.description`)}
      </p>
      <div className="features-container">
        {t(`featureHighlights.features`) &&
          t(`featureHighlights.features`).map((feature, index) => (
            <div key={index}>
              <div className="feature-item" key={index}>
                <img
                  src={feature.icon}
                  alt={feature.title}
                  className="feature-icon"
                />
              </div>
              <p className="feature-title">{feature.title}</p>
            </div>
          ))}
      </div>
    </div>
  );
};

export default FeatureHighlights;
